import { FRAUD_TYPE_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useFraudTypeList } from './hook';
import { FraudTypeListProps } from './props';

export const FraudTypeList = ({ filters }: FraudTypeListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useFraudTypeList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${FRAUD_TYPE_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
